<template lang="pug">
AppToggleDropdown(
  direction="right"
  trigger-classes="dropdown-toggle"
)
  template(#trigger)
    a.btn.btn-primary
      span
        | Actions
      i.hi.hi-caret
  li(
    v-for="item in permittedItems"
    :key="item.name"
  )
    a(
      v-tooltip="!!item.disabledTooltip"
      data-placement="left"
      :target="item.target"
      :href="item.href"
      :data-original-title="item.disabledTooltip"
      v-bind="item.testId ? { 'data-testid': item.testId } : {}"
      :disabled="!!item.disabledTooltip ? 'disabled' : null"
      @click="onClick(item)"
    )
      i(:class="item.class")
      | {{ item.name }}
    .settings(v-if="item.settings && item.settings.permitted")
      a(
        target="_blank"
        :href="item.settings.path"
      )
        i.hi-settings
</template>

<script>
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'SchedulesFiltersActionsDropdown',
  computed: {
    ...mapInertiaProps({
      settingPaths: 'setting_paths',
      userPermissions: 'user_permissions',
      currentUserRole: 'current_user_role',
      organizationId: ({ organization }) => organization.id,
    }),
    permittedItems() {
      return this.items.filter((item) => item.permitted === true);
    },
    items() {
      return [
        {
          name: 'Create shifts',
          class: 'hi hi-plus-circle-filled',
          testId: 'schedules-action-create-shifts',
          handler: () => this.$emit('open-dialog', 'shifts'),
          permitted: this.userPermissions.schedules.bulk_manage,
        },
        {
          name: 'Delete shifts',
          class: 'hi hi-delete-xs',
          handler: () => this.$emit('open-dialog', 'delete_shifts'),
          permitted: this.userPermissions.schedules.bulk_manage,
        },
        {
          name: 'Add time off request',
          class: 'hi hi-external',
          handler: () => this.openTimeOffRequest(),
          settings: { path: this.settingPaths.time_off, permitted: this.userPermissions.time_offs.manage },
          permitted: true,
        },
        {
          name: 'Add holiday',
          class: 'hi hi-external',
          handler: () => this.openHoliday(),
          settings: { path: this.settingPaths.holidays, permitted: this.userPermissions.holidays.manage },
          permitted: this.userPermissions.holidays.manage,
          disabledTooltip: !this.userPermissions.holidays.create && 'Enable it on the settings page',
        },
        {
          name: 'Add to my calendar',
          class: 'hi hi-calendar',
          handler: () => this.openAddToCalendar(),
          permitted: true,
        },
        {
          name: 'Schedules settings',
          class: 'hi hi-settings',
          href: this.settingPaths.calendar,
          target: '_blank',
          handler: () => false,
          permitted: this.userPermissions.schedules.manage,
        },
      ];
    },
  },
  methods: {
    onClick(item) {
      !item.disabledTooltip && item.handler();
    },
    openTimeOffRequest() {
      this.$emit('open-dialog', 'time_off_request');
      this.analyticsTrack('Time off request calendar clicked');
    },
    openHoliday() {
      this.$emit('open-dialog', 'holidays');
      this.analyticsTrack('Holiday calendar clicked');
    },
    openAddToCalendar() {
      this.$emit('open-dialog', 'icalendar');
      this.analyticsTrack('Calendar add clicked');
    },
    analyticsTrack(event, props = {}) {
      const defaultProperties = {
        organization_id: this.organizationId,
        user_role: this.currentUserRole,
        current_page_title: document.title,
        current_url: document.url,
      };

      window.analytics?.track(event, {
        ...defaultProperties,
        ...props,
      });
    },
  },
};
</script>
